import { Tag } from "./Tag";
import { PlanInfo } from "./PlanInfo";
import { OwnerInfo } from "./OwnerInfo";
import { Library } from "./Library";
import type { Chapter } from "./Chapter";

export interface ArticleFileItem {
  fileKey: string;
  fileSubUrl: string;
  fileUrl: string;
}

// 記事情報
export class ArticleInfo {
  constructor(
    public id: string = "",
    public thumbnailImage: string = "", // サムネイル画像
    public thumbnailKey: string = "",
    public contentsTitle: string = "", // タイトル
    public description: string = "", // タイトル
    public contentsUrl: string = "", // ファイルパス
    public contentsKey: string = "",
    public tags: Tag[] = [],
    public postDateTime: string = "", // 投稿日
    public isFree: boolean = false,
    public isFeatured: boolean = false,
    // [ユーザー状態] 現在のユーザーがこのコンテンツにアクセス可能か
    // 限定プラン未設定: 講座契約済みならtrue
    // 限定プラン設定済: 該当プラン入会済みならtrue
    // 講師・未契約者: false
    public isContract: boolean = false,
    public isComplete: boolean = false,
    public unread: boolean = false,

    public plan: PlanInfo | undefined = undefined,
    public planOwner: OwnerInfo | undefined = undefined, // オーナー

    public contentsType: string = "",
    public isUnread: boolean = false,
    public isOwner: boolean = false,
    public isGood: boolean = false, // 自分がいいねしているか
    public goodCount: number = 0, // いいね数

    public articleBody: string = "", // マークダウン形式の説明
    public articleFiles: ArticleFileItem[] = [], // 記事ファイルのキー
    public articleStatus: "PUBLISH" | "DRAFT" = "DRAFT", // 下書きか本番か

    public publishStatus: "PUBLISH" | "PRIVATE" | "LIMITED" = "PRIVATE", // 公開設定
    public publishDateTime: string = "", // 公開日
    public postUserId: string = "", // 投稿者ID

    public isBookmark: boolean = false, // ブックマークしているか
    public libraries: Library[] = [], // ライブラリ
    public contentsGroupKey: string | null = null, // コンテンツグループキー
    public chapters: Chapter[] | undefined = undefined, // チャプター
    public viewingRestrictionDays: number | null = null, // 閲覧権限制限日数
    public viewCount: number = 0, // 閲覧数
    // [コンテンツ設定] 限定プラン制限の有無
    public isLimitedPlan: boolean = false,
    // [コンテンツ設定] アクセス可能な限定プランID一覧
    public limitedPlanPriceIds: number[] = [],
    // [ユーザー状態] プラン価格によって制限されているか（APIで取得ではなくプログラムで付与）
    public isLimitedByPlanPrice: boolean = false,
  ) {}
}
